module["exports"] = {
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
  wide_context: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
  abbr: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbr_context: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]
};